import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { LoginComponentProps } from '../../types/LoginFormData';
import { TSPCategory, TSPConfig } from '../types';

const ezlynkConfig: TSPConfig = {
  key: 'ezlynk',
  name: 'EZLynk',
  imageName: 'EZLynk',
  category: TSPCategory.CUSTOM,
  helpText: 'Enter your DOT number to connect your EZLynk account.',
  loginComponent: (props: LoginComponentProps) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'DOT Number',
          name: 'dotnumber',
          type: 'number',
          required: true,
        },
      ]}
    />
  ),
};

export default ezlynkConfig;
